import { createSlice } from "@reduxjs/toolkit";
import {
  createCouponBuilder,
  deleteCouponBuilder,
  getCouponsBuilder,
  checkCouponBuilder,
} from "./builder";

const initialState = {
  coupons: {
    data: [],
    applied: null,
    loading: false,
    deleteLoading: false,
    createLoading: false,
    checkCouponLoading: false,
    error: null,
  },
};

export const couponsSlice = createSlice({
  name: "couponsInfo",
  initialState,
  reducers: {
    resetAppliedCoupon: (state) => {
      state.coupons.applied = null;
    },
  },
  extraReducers: (builder) => {
    getCouponsBuilder(builder);
    checkCouponBuilder(builder);
    createCouponBuilder(builder);
    deleteCouponBuilder(builder);
    builder.addCase("logout", () => ({ ...initialState, loggedIn: false }));
  },
});

export const { resetAppliedCoupon } = couponsSlice.actions;

export const selectCoupons = (state) => state.couponsInfo.coupons;

export default couponsSlice.reducer;
